import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { CommonService } from '../../services/common.service';

@Component({
    selector: 'app-commerce',
    templateUrl: './commerce.component.html',
    styleUrls: ['./commerce.component.css'],
    standalone: false
})
export class CommerceComponent implements OnInit {
  @Input() detail;
  @Input() edit: Boolean;
  @Input() add: Boolean;
  @Input() hidetitle: Boolean;
  @Output() show = new EventEmitter<any>();
  @Output() prixNegocier = new EventEmitter<any>();
  @Output() nomenclatureNegocier = new EventEmitter<any>();
  @Output() libelleNegocier = new EventEmitter<any>();
  @Output() cap = new EventEmitter<any>();
  @Output() capDND = new EventEmitter<any>();
  @Output() capClient = new EventEmitter<any>();
  @Output() limiterExutoire = new EventEmitter<any>();
  default = 0;
  nbdigit;
  result: any[] = [];
  modepaie;
  modefacturejrxml;
  jours: any[] = [];
  typemodepaie;
  comm1;
  comm2;
  formspec;
  typeQteDASRI;
  site;
  siteCA;
  groupimp;
  typeflux;
  listCom = [];
  listMode = [];
  listFormspe = [];
  listQtedasri = [];
  listSite = [];
  listGrpimp = [];
  listTypeflux = [];
  listeDate = [];
  listChampSupp = [];
  listFiliereFact = [];
  listPrestation = [
    { id: 0, libelle: 'Depot' },
    { id: 1, libelle: 'Rotation' },
    { id: 2, libelle: 'Retrait' },
    { id: 3, libelle: 'Autre' },
    { id: 4, libelle: 'Location' },
    { id: 5, libelle: 'Forfait' },
  ];
  @ViewChild('prixPrestation') prixPrestation;
  @ViewChild('confirmationChorus') confirmationChorus;
  @ViewChild('msg') msg;
  error = '';
  cpatchaTextBox = '';
  code = '';
  droit: any = {};
  user;
  societe: any = {};
  masqueModificationExterne: Boolean = false;
  masqueClientPraxy: Boolean = false;
  modePaieAchat
  typemodepaieAchat
  listCategorieDetenteurHU: any = [{ id: 0, libelleObjetEntite: 'Aucun', libelle: 'Aucun' }];
  listNatureTonnagesHU: any = [{ id: 0, libelleObjetEntite: 'Aucun', libelle: 'Aucun' }];

  constructor(public common: CommonService, private modalService: BsModalService) { }

  ngOnInit() {
    this.user = this.common.local.getObject('userDetail') || {};
    this.droit['droitFicheCom'] = ((this.user.clefDroit & 0x00100000) !== 0) ? true : false;
    console.log('droitFicheCom', this.droit['droitFicheCom'])
    this.societe = this.common.local.getObject('paramSociete') || {};
    this.nbdigit = this.societe.nbDigitDevise;
    this.masqueModificationExterne = this.societe.URLCreationClient ? true : false;
    this.jours = Array.from({ length: 31 }, (v, k) => k + 1);
    this.listChamp();
    this.searchModepaie('');
    this.getListCategorieDetenteurHU();
    this.getListNatureTonnagesHU();
    for (let i = 0; i < 31; i++) {
      this.listeDate.push({ id: i, libelleObjetEntite: i + 1 });
    }
    this.detail.ChampsFiliere = this.detail.ChampsFiliere || [];
    this.listFiliereFact.forEach(elt => {
      this.detail.ChampsFiliere.forEach(fil => {
        if (fil.libelle === elt.libelle) {
          elt.actif = true;
          elt.valeur = fil.codeClient;
        }
      });
    });

    if (!this.listChampSupp) {
      this.listChampSupp = [];
    }

    if (!this.detail.ChampsClientSupp) {
      this.detail.ChampsClientSupp = [];
    }

    this.listChampSupp.forEach(elt => {
      this.detail.ChampsClientSupp.forEach(champ => {
        if (champ.nomChamp === elt.nom) {
          elt.actif = true;
          elt.valeur = champ.valeur;
        }
      });
    });


    // console.log(this.detail['listFiliereFact'], this.detail['listChampsClientSupp']);
    this.masqueClientPraxy = (this.societe.partenairePraxy ? true : false) || ((this.societe.ecorecExterne ? true : false)
              && (this.societe.assoEchangeCode ? true : false));

  }

  getListCategorieDetenteurHU() {
    const param = {
      'servlet': 'DBGestionObjetEntite',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 10
        }
      }
    };

    return this.common.post('', { param: param }).then(datas => {
      if (this.common.verifySession(datas)) {
        (datas.data || []).forEach(elt => {
          elt.libelleObjetEntite = `${elt.code ? elt.code + '/' : ''}${elt.libelle || ''}`;
        });
        this.listCategorieDetenteurHU = [...this.listCategorieDetenteurHU, ...datas.data];
      }
    });
  }

  getListNatureTonnagesHU() {
    const param = {
      'servlet': 'DBGestionObjetEntite',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 11
        }
      }
    };

    return this.common.post('', { param: param }).then(datas => {
      if (this.common.verifySession(datas)) {
        (datas.data || []).forEach(elt => {
          elt.libelleObjetEntite = `${elt.code ? elt.code + '/' : ''}${elt.libelle || ''}`;
        });
        this.listNatureTonnagesHU = [...this.listNatureTonnagesHU, ...datas.data];
      }
    });
  }

  listChamp() {
    this.listChampSupp = this.common.getType('typeChampsupp') || [];
    this.listFiliereFact = this.common.getType('typefiliere') || [];
    this.typemodepaie = this.common.getItem(this.common.getType('typeModepaie'), (this.detail.modePaie || 0));
    this.typemodepaieAchat = this.common.getItem(this.common.getType('typemodepaieAchat'), (this.detail.typemodepaieAchat || 0));
    this.comm1 = this.common.getItem(this.common.getType('typeCom'), (this.detail.userCommercial ? this.detail.userCommercial.id : 0));
    this.comm2 = this.common.getItem(this.common.getType('typeCom'), (this.detail.userCommercial2 ? this.detail.userCommercial2.id : 0));
    this.formspec = this.common.getItem(this.common.getType('typeFormspec'), this.detail.formatFactureJRXML);
    this.typeQteDASRI = this.common.getItem(this.common.getType('typeQteDASRI'), this.detail.qteDASRIMois ? this.detail.qteDASRIMois.id : 0);
    this.site = this.common.getItem(this.common.getType('typeSite'), this.detail.sitePrestation ? this.detail.sitePrestation.id : 0);
    this.siteCA = this.common.getItem(this.common.getType('typeSite'), this.detail.siteCA ? this.detail.siteCA.id : 0);
    this.groupimp = this.common.getItem(this.common.getType('typeimpression'), this.detail.groupeImpression ?
      this.detail.groupeImpression.id : 0);
    this.typeflux = this.common.getItem(this.common.getType('typeFlux'), this.detail.typeFlux ? this.detail.typeFlux.id : 0);

    // Completer nom prenom; this.detail.userCommercial1 est déjà completé dans le back-end
    const u2 = this.common.getObjetById(this.common.getType('typeCom'), (this.detail.userCommercial2 ? this.detail.userCommercial2.id : 0));
    if (u2) {
      this.detail.userCommercial2 = u2;
    }

    return true;
  }

  changeFiliere() {
    this.detail['listFiliereFact'] = [];
    this.detail['listChampsClientSupp'] = [];
    this.listFiliereFact.forEach(elt => {
      if (elt.actif) {
        const FiliereFact = {
          id: elt.id,
          libelle: elt.libelle,
          clientFact: {
            id: this.detail['id'] || '0',
            codeClient: elt.valeur
          }
        };
        this.detail['listFiliereFact'].push(FiliereFact);
      }
    });

    if (!this.listChampSupp) {
      this.listChampSupp = [];
    }
    this.listChampSupp.forEach(elt => {
      if (elt.actif) {
        const FiliereFact = {
          id: elt.id,
          nom: elt.nom,
          valeur: elt.valeur
        };
        this.detail['listChampsClientSupp'].push(FiliereFact);
      }
    });

  }

  getValueFiliere(id) {
    let item;
    if (this.detail.ChampsFiliere) {
      this.detail.ChampsFiliere.filter(elt => {
        if (parseInt(elt.clefFiliereFacturation, 10) === parseInt(id, 10)) {
          item = elt;
        }
      });
    }
    return item ? item.libelle : '';
  }

  getValueChampsupp(id) {
    let item;
    if (this.detail.ChampsClientSupp) {
      this.detail.ChampsClientSupp.filter(elt => {
        if (parseInt(elt.clefChampsClientSupp, 10) === parseInt(id, 10)) {
          item = elt;
        }
      });
    }
    return item ? item.valeur : '';
  }

  searchCommercial(event) {
    this.listCom = [{ id: 0, libelleObjetEntite: 'Tous', libelle: 'Tous' }];
    // console.log(this.common.getType('typeCom'));
    this.common.getType('typeCom').forEach(elt => {
      // if (elt.libelle.startsWith(event) || elt.libelle.toLowerCase().startsWith(event)) {
      elt.libelleObjetEntite = elt.libelle;
      this.listCom.push(elt);
      // }
    });
  }

  saveGrp($event) {
    this.detail.groupeImpression = $event;
    console.log('dd',this.detail)
  }

  showFactAuto() {
    this.show.emit();
  }

  searchModepaie(event) {
    // this.listMode = [];
    // this.common.getType('typeModepaie').forEach(elt => {
    //   // if (elt.libelle.startsWith(event) || elt.libelle.toLowerCase().startsWith(event)) {
    //   elt.libelleObjetEntite = elt.libelle;
    //   this.listMode.push(elt);
    //   // }
    // });
    this.listMode = [];
    const param = {
      'servlet': 'DBGestionTypePaiement',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 2
        },
      }
    };

    this.common.post('', { param: param }).then(datas => {
      if (this.common.verifySession(datas)) {
        if (datas.data) {
          const liste = (datas.data || []).filter(elt => !elt.masque);
          if (liste.length) {
            liste.forEach(elt => {
              elt.libelleObjetEntite = elt.libelleObjetEntite || elt.libelle;
              this.listMode.push(elt);
              if (this.detail.modePaie && parseInt(this.detail.modePaie, 10) === elt.id) {
                this.modepaie = elt;
                this.typemodepaie = elt.libelleObjetEntite;
              }
              if (this.detail.modePaieAchat && parseInt(this.detail.modePaieAchat, 10) === elt.id) {
                this.modePaieAchat = elt;
                this.typemodepaieAchat = elt.libelleObjetEntite;
              }
            });
            // this.common.sortByID(this.listMode);
          }
        }
      }
    });
  }

  searchFactureJRXML(event) {
    this.listFormspe = [{ id: 0, libelleObjetEntite: 'Aucun', libelle: 'Aucun' }];
    this.common.getType('typeFormspec').forEach(elt => {
      // if (elt.libelle.startsWith(event) || elt.libelle.toLowerCase().startsWith(event)) {
      elt.libelleObjetEntite = elt.libelle;
      this.listFormspe.push(elt);
      // }
    });
  }

  searchDASRIMois(event) {
    this.listQtedasri = [{ id: 0, libelleObjetEntite: 'Aucun', libelle: 'Aucun' }];
    this.common.getType('typeQteDASRI').forEach(elt => {
      // if (elt.libelle.startsWith(event) || elt.libelle.toLowerCase().startsWith(event)) {
      elt.libelleObjetEntite = elt.libelle;
      this.listQtedasri.push(elt);
      // }
    });
  }

  searchSite(event) {
    this.listSite = [{ id: 0, libelleObjetEntite: 'Aucun', libelle: 'Aucun' }];
    this.common.getType('typeSite').forEach(elt => {
      // if (elt.libelle.startsWith(event) || elt.libelle.toLowerCase().startsWith(event)) {
      elt.libelleObjetEntite = elt.libelle;
      this.listSite.push(elt);
      // }
    });
  }

  searchGrpImp(event) {
    this.listGrpimp = [{ id: 0, libelleObjetEntite: 'Aucun', libelle: 'Aucun' }];
    this.common.getType('typeimpression').forEach(elt => {
      // if (elt.libelle.startsWith(event) || elt.libelle.toLowerCase().startsWith(event)) {
      elt.libelleObjetEntite = elt.libelle;
      this.listGrpimp.push(elt);
      // }
    });
  }

  searchtypeflux(event) {
    this.listTypeflux = [];
    this.common.getType('typeFlux').forEach(elt => {
      // if (elt.libelle.startsWith(event) || elt.libelle.toLowerCase().startsWith(event)) {
      elt.libelleObjetEntite = elt.libelle;
      this.listTypeflux.push(elt);
      // }
    });
  }

  openPrixPrestation() {
    this.getTarifPrest();
    this.common.openModal(this.modalService, this.prixPrestation);
  }

  getTarifPrest() {
    const client = Object.assign({}, this.detail);
    client.nomclass = 'Client';
    const param = {
      'servlet': 'DBGetTarifPrest',
      'module': 'Recylog',
      'type': 'liste',
      'compression': 'false',
      'leger': 'true',
      'forcerSerialisation': 'true',
      'data': ['DBGetTarifPrest', client]
    };

    return this.common.post('', { param: param }).then(datas => {
      if (this.common.verifySession(datas)) {
        const data = datas.data ? datas.data[0] || [] : [];

        this.listPrestation.forEach((elt, index) => {
          if (data[index]) {
            elt['checked'] = true;
            elt['tarif'] = data[index].tarif;
          } else {
            elt['checked'] = false;
          }
        });
      }
    });
  }

  saveTarifPrest() {
    const client = Object.assign({}, this.detail);
    client.nomclass = 'Client';
    const data = [];
    this.listPrestation.forEach(elt => {
      if (elt['checked']) {
        data[elt.id] = {};
        data[elt.id]['tarif'] = elt['tarif'];
      } else {
        data[elt.id] = null;
      }
    });
    client.tabArticlePrest = data;
    const param = {
      'servlet': 'DBMAJTarifPrest',
      'module': 'Recylog',
      'type': 'liste',
      'compression': 'false',
      'data': ['DBMAJTarifPrest', client]
    };

    return this.common.post('', { param: param }).then(datas => {
      if (this.common.verifySession(datas)) {
        // console.log(datas);
      }
    });
  }

  revertTarif(item) {
    item.tarif = '';
  }

  showPrixNego() {
    // console.log('Calling showPrixNego()');
    this.prixNegocier.emit();
  }

  showNomenclature() {
    this.nomenclatureNegocier.emit();
  }

  onChangeSiteSociete() {
    if (this.detail.isGroupe) {
      this.detail.societeGroupe = false;
    }
  }

  onChangeGrpSociete() {
    if (this.detail.societeGroupe) {
      this.detail.isGroupe = false;
    }
  }

  showLibelleNego() {
    this.libelleNegocier.emit();
  }

  showCap() {
    this.cap.emit();
  }

  showCapDND() {
    this.capDND.emit();
  }

  showCapClient() {
    this.capClient.emit();
  }

  showLimiteExu() {
    this.limiterExutoire.emit();
  }

  verifierCodeConfirmation() {
    this.createCaptcha();
    this.common.openModal(this.modalService, this.confirmationChorus);
  }

  createCaptcha() {
    //clear the contents of captcha div first         
    setTimeout(function () {
      document.getElementById('captcha').innerHTML = "";
    }, 3000);

    let charsArray =
      "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ@!#$%^&*";
    let lengthOtp = 6;
    let captcha = [];
    for (let i = 0; i < lengthOtp; i++) {
      //below code will not allow Repetition of Characters
      let index = Math.floor(Math.random() * charsArray.length + 1); //get the next character from the array
      if (captcha.indexOf(charsArray[index]) == -1)
        captcha.push(charsArray[index]);
      else i--;
    }

    let canv = document.createElement("canvas");
    canv.id = "captcha";
    canv.width = 100;
    canv.height = 50;
    let ctx = canv.getContext("2d");
    ctx.font = "25px Georgia";
    ctx.strokeText(captcha.join(""), 0, 30);
    //storing captcha so that can validate you can save it somewhere else according to your specific requirements
    this.code = captcha.join("");
    setTimeout(function () {
      document.getElementById("captcha").appendChild(canv); // adds the canvas to the body element            
    }, 3000);
  }

  validationCodeChorus() {
    if (this.cpatchaTextBox === this.code) {
      this.common.closeModal();
    } else {
      this.error = 'Veuillez saisir le code de confirmation';
      this.common.openModal(this.modalService, this.msg);
    }
  }

  revertValeurChorus() {
    this.detail.isChorus = !this.detail.isChorus
  }

  selectGrpImpr(event) {
    this.detail.groupeImpression = event;
    this.groupimp = this.common.getItem(this.common.getType('typeimpression'), this.detail.groupeImpression ?
      this.detail.groupeImpression.id : 0);
  }
}
